import $ from "jquery";

export default {
    mounted(){
        const delay = 0;
        const offset = 150;

        document.addEventListener('invalid', function(e){
            $(e.target).addClass("invalid");
            $('.page').animate({scrollTop: $($(".invalid")[0]).offset().top - offset }, delay);
        }, true);
        document.addEventListener('change', function(e){
            $(e.target).removeClass("invalid")
        }, true);
    },
}
